
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://static.readdy.ai/image/a0544820e0625081891e0a711cac5596/a9ac708fe8bef9b154545024ad09cfeb.jpeg)',
        }}
      ></div>
      
      <div className="absolute inset-0 bg-gradient-to-r from-ov-sand-900/80 via-ov-sand-800/60 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-3xl">
          <div className="mb-6 inline-flex items-center space-x-2 px-4 py-2 bg-ov-cream-50/20 backdrop-blur-sm rounded-full border border-ov-cream-200/30">
            <i className="ri-star-fill text-ov-cream-400"></i>
            <span className="text-ov-cream-50 text-sm font-medium">Locally Owned for 25+ Years</span>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold text-ov-cream-50 mb-6 font-serif leading-tight">
            Experience the<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-ov-teal-400 to-ov-blue-300">
              Florida Keys
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-ov-cream-100 mb-8 leading-relaxed">
            Discover Islamorada's iconic bayfront inn and sports pub. Authentic Keys hospitality, delicious dining, comfortable rooms, and unforgettable sunsets await you.
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://hotels.cloudbeds.com/en/reservation/KsGpNF"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-gradient-to-r from-ov-teal-600 to-ov-blue-500 text-white rounded-lg font-semibold text-lg hover:shadow-2xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-hotel-bed-line mr-2 text-xl"></i>
              Book Your Stay
            </a>
            <a
              href="https://order.toasttab.com/online/the-ocean-view-84500-overseas-hwy"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center px-8 py-4 bg-ov-cream-50/20 backdrop-blur-sm text-ov-cream-50 rounded-lg font-semibold text-lg border-2 border-ov-cream-200/30 hover:bg-ov-cream-50/30 transition-all duration-300 whitespace-nowrap"
            >
              <i className="ri-restaurant-line mr-2 text-xl"></i>
              View Menu
            </a>
          </div>

          <div className="mt-12 flex items-center space-x-8">
            <div className="flex items-center space-x-2">
              <i className="ri-map-pin-line text-ov-teal-400 text-xl"></i>
              <span className="text-ov-cream-50 text-sm">Islamorada, Florida Keys</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-phone-line text-ov-teal-400 text-xl"></i>
              <a href="tel:+13056648052" className="text-ov-cream-50 text-sm hover:text-ov-teal-400 transition-colors">
                (305) 664-8052
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-ov-cream-50 text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
